<script setup>
import {computed} from "vue";
import {kitActivityLogCategories} from "@/composables/kit-activity-logs/useKitActivityLogs";

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
  page: {
    type: [Object, null],
    required: true,
  },
  location: {
    type: [Object, null],
    required: true,
  },
})

const icon = computed(() => {
  switch (props.category) {
    case kitActivityLogCategories.ONSITE:
      return 'icons/link';
    case kitActivityLogCategories.PLATFORM_WIDE:
      return 'icons/project-plan';
    case kitActivityLogCategories.LOCAL:
      return 'icons/business-location';
    default:
      return '';
  }
});

const tooltip = computed(() => {
  switch (props.category) {
    case kitActivityLogCategories.ONSITE:
      return 'This change was made to your website';
    case kitActivityLogCategories.LOCAL:
      return 'This change was made to your GBP listing';
    case kitActivityLogCategories.PLATFORM_WIDE:
      return 'This change was made to the SEO strategy on the platform';
    default:
      return '';
  }
});
</script>

<template>
  <div
    v-tooltip="{
      content: tooltip,
      placement: 'bottom',
      theme: 'dark-blue-tooltip',
    }"
    class="tw-flex tw-justify-center tw-items-center tw-w-10 tw-h-10 tw-rounded-xl tw-bg-neutral-100 tw-shrink-0"
  >
    <svg-vue
      :icon="icon"
      class="tw-w-6 tw-h-6 tw-text-neutral-900"
    />
  </div>

  <div v-if="category === kitActivityLogCategories.PLATFORM_WIDE">
    <span>SEO Strategy</span>
  </div>

  <div v-else-if="category === kitActivityLogCategories.LOCAL">
    <span>Google Business Profile ({{ location?.title }})</span>
  </div>

  <div
    v-else-if="category === kitActivityLogCategories.ONSITE"
    class="tw-flex tw-flex-wrap tw-gap-0.5 tw-overflow-hidden"
  >
    <span>Website - </span>
    <a
      v-tooltip="{
        placement: 'bottom',
        theme: 'dark-blue-tooltip',
        content: `${page?.url}`,
      }"
      :href="page?.url"
      target="_blank"
      class="tw-text-primary-200 tw-underline tw-truncate"
    >
      {{ page?.path }}
    </a>
  </div>
</template>
